import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SharedService } from "@shared/services/shared.service";

import { AdminService } from "app/services/admin/admin.service";
import { AddComplaintFilesComponent } from "./addComplaintFile.component";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { IFileView } from "app/models/mainMenu/mainMenu";
import { Subscription } from "rxjs";


@Component({
  selector: 'complaint-complaintFiles',
  templateUrl: './complaintFiles.component.html',
  styleUrls: ['./complaintFiles.component.scss']
})

export class ComplaintFilesComponent implements OnInit {

  @Input() file: string = '';
  @Output() refresh = new EventEmitter<boolean>();

  complaintSubscription: Subscription;
  filesList: IFileView[] = [];

  displayedColumns: string[] = ['name', 'description', 'staff', 'date'];
  dataSource = new MatTableDataSource<any>(this.filesList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    public complaintService: ComplaintService,
    private sharedService: SharedService,
    private adminService: AdminService,
    private modalService: MatDialog,
  ) {

  }

  ngOnInit(): void {
    this.complaintSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
      if (data == 1) {
        this.init();
      }
    });
  }
  
  ngOnDestroy() {
    this.complaintSubscription.unsubscribe();
  }
 

  init(){
    this.filesList = this.complaintService.currentComplaint.files;
    this.dataSource.data = this.filesList;  
    this.dataSource.sort = this.sort;
  }

  addFile() {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.data = { complaintId: this.complaintService.currentComplaint.complaintId };
    const dialogRef = this.modalService.open(AddComplaintFilesComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'refresh'){
          this.refresh.emit(true);
        }
      },
      error => console.log('error: ', error),
      () => { }
    );  
  }

  rowClick(file: IFileView){

    this.sharedService.getAttachment(file.id).subscribe(
      (result) => {
        this.sharedService.downloadFile(file.name, result);
      },
      error => {
        this.sharedService.toastr.error("Could not get Files: " + error.message);
      }
    );
  }
  
}
